import {
  CustomMappingType,
  type ICustomMapping,
} from '@principle-theorem/practice-migrations/interfaces';
import { CustomMapping } from '../../../custom-mapping';
import {
  FeeScheduleMappingHandler,
  type IBaseMigrationFeeSchedule,
} from '../../../mappings/fee-schedules';
import {
  type CorePracticeInsuranceOption,
  type ICorePracticeInsuranceOption,
  InsuranceOptionSourceEntity,
} from '../../source/entities/insurance-options';

export const INSURANCE_TO_FEE_SCHEDULE_CUSTOM_MAPPING_TYPE =
  'insuranceToFeeSchedule';

export const INSURANCE_TO_FEE_SCHEDULE_MAPPING: ICustomMapping =
  CustomMapping.init({
    metadata: {
      label: 'Insurance To Fee Schedule',
      description:
        'Used to set the preferred fee schedule of patients from their Core Practice insurance, e.g. map Veterans Affairs to the DVA fee schedule. Unmapped insurances leave the patient on the default fee schedule.',
      type: INSURANCE_TO_FEE_SCHEDULE_CUSTOM_MAPPING_TYPE,
    },
    type: CustomMappingType.DocumentReference,
    labelOverrides: {
      sourceIdentifier: 'Id',
      sourceLabel: 'Insurance',
      destinationIdentifier: 'Principle Fee Schedule',
    },
  });

export class CorePracticeInsuranceToFeeScheduleMappingHandler extends FeeScheduleMappingHandler<
  CorePracticeInsuranceOption,
  InsuranceOptionSourceEntity
> {
  override customMapping = INSURANCE_TO_FEE_SCHEDULE_MAPPING;
  override sourceEntity = new InsuranceOptionSourceEntity();
  translateFn = (
    record: ICorePracticeInsuranceOption
  ): IBaseMigrationFeeSchedule => record;
}
